/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CounterCard from "@jumbo/components/CounterCard";
import { Grid } from "@mui/material";
import { userType } from "app/helpers/userType";
import { useDispatch, useSelector } from "react-redux";
import { getDashboardList } from "app/redux/slice/dashboardSlice";

const Home = () => {
  const { isMA } = userType();
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state?.dashboard);
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    officePermission: false,
    millPermission: false,
    knitterPermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        officePermission: true,
        millPermission: true,
        knitterPermission: true,
      });
    } else {
      let permissionValue = {
        officePermission: false,
        millPermission: false,
        knitterPermission: false,
      };
      const rolePermission = permissionData?.filter((item) => {
        return item?.moduleName?.includes("Dashboard") && item;
      });
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.displayName === "Office") {
            permissionValue.officePermission = true;
          }
          if (num?.displayName === "Mill") {
            permissionValue.millPermission = true;
          }
          if (num?.displayName === "knitter") {
            permissionValue.knitterPermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  useEffect(() => {
    getPermission();
    dispatch(getDashboardList());
  }, []);

  return (
    <>
      {permission.officePermission && (
        <>
          <h1>Office</h1>
          <Grid container spacing={2}>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Products"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalProduct ?? 0}
              />
            </Grid>

            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Variants"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalVariant ?? 0}
              />
            </Grid>

            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Vendors"}
                backgroundColor={"#E44A77"}
                count={dashboardData?.list?.totalSupplierOffice ?? 0}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <CounterCard
                title={"Total Purchase Orders"}
                backgroundColor={"#6c8033"}
                count={dashboardData?.list?.totalPurchaseOrder ?? 0}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <CounterCard
                title={"Total Invoices"}
                backgroundColor={"#e66e00"}
                count={dashboardData?.list?.totalInvoice ?? 0}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <CounterCard
                title={"Total Pre-Booked Orders"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalPreBook ?? 0}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <CounterCard
                title={"Total Staff Members"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalUserOffice ?? 0}
              />
            </Grid>
          </Grid>
        </>
      )}

      {permission.millPermission && (
        <>
          <h1>Mill</h1>
          <Grid container spacing={2}>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Products"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalProduct ?? 0}
              />
            </Grid>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Variants"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalVariant ?? 0}
              />
            </Grid>

            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Vendors"}
                backgroundColor={"#E44A77"}
                count={dashboardData?.list?.totalSupplierMill ?? 0}
              />
            </Grid>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Purchases"}
                backgroundColor={"#6c8033"}
                count={dashboardData?.list?.totalMillPurchaseOrder ?? 0}
              />
            </Grid>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Orders"}
                backgroundColor={"#e66e00"}
                count={dashboardData?.list?.totalMillOrder ?? 0}
              />
            </Grid>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Staff Members"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalUserMill ?? 0}
              />
            </Grid>
          </Grid>
        </>
      )}
      {permission.knitterPermission && (
        <>
          <h1>Knitter</h1>
          <Grid container spacing={2}>
            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Orders"}
                backgroundColor={"#6f42c1"}
                count={dashboardData?.list?.totalKnitterOrder ?? 0}
              />
            </Grid>

            <Grid item sm={4} xs={6}>
              <CounterCard
                title={"Total Vendors"}
                backgroundColor={"#E44A77"}
                count={dashboardData?.list?.totalSupplierKnitter ?? 0}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default Home;
